// src/components/Dashboard.js
import React, { useState, useEffect } from 'react';
import { getStudyGroups, deleteStudyGroup } from '../api';
import { Link } from 'react-router-dom';
import '../App.css';

const Dashboard = () => {
  const [studyGroups, setStudyGroups] = useState([]);
  const [subject, setSubject] = useState("");
  const token = localStorage.getItem("token");
  const storedUser = localStorage.getItem("user");
  const currentUser = storedUser ? JSON.parse(storedUser) : null;
  const currentUserId = currentUser ? currentUser.user_id : null;
  // Derive friendly username from email (e.g. "savi" from "savi@library.ok")
  const currentUsername = currentUser ? currentUser.email.split('@')[0] : null;

  useEffect(() => {
    fetchGroups();
  }, []);

  const fetchGroups = () => {
    getStudyGroups()
      .then(res => setStudyGroups(res.data))
      .catch(err => console.error(err));
  };

  const handleSearch = (e) => {
    e.preventDefault();
    getStudyGroups(subject)
      .then(res => setStudyGroups(res.data))
      .catch(err => console.error(err));
  };

  const handleDelete = async (groupId) => {
    if (!token) {
      alert("You must be logged in to delete a study group.");
      return;
    }
    if (window.confirm("Are you sure you want to delete this study group?")) {
      try {
        await deleteStudyGroup(groupId, token);
        alert("Study group deleted successfully!");
        fetchGroups();
      } catch (err) {
        console.error(err);
        alert(err.response?.data?.error || "Error deleting study group.");
      }
    }
  };

  let myGroups = [];
  let createdGroups = [];
  let otherGroups = [];

  if (currentUserId && currentUsername) {
    myGroups = studyGroups.filter(group => group.members.includes(currentUsername));
    createdGroups = studyGroups.filter(group => String(group.creator) === String(currentUserId));
    otherGroups = studyGroups.filter(
      group => !group.members.includes(currentUsername) &&
               String(group.creator) !== String(currentUserId)
    );
  } else {
    otherGroups = studyGroups;
  }

  return (
    <div className="container">
      <h1>Study Groups Dashboard</h1>
      <form onSubmit={handleSearch} className="search-form">
        <input 
          type="text"
          placeholder="Search by subject"
          value={subject}
          onChange={(e) => setSubject(e.target.value)}
        />
        <button type="submit">Search</button>
      </form>
      {currentUser ? (
        <>
          <h2>Groups You Are In</h2>
          <div className="card-container">
            {myGroups.length > 0 ? myGroups.map(group => (
              <div className="card" key={group._id}>
                <h2>{group.subject}</h2>
                <p><strong>Meeting Time:</strong> {new Date(group.meeting_time).toLocaleString()}</p>
                {group.session_type === 'offline' && <p><strong>Location:</strong> {group.location}</p>}
                {group.session_type === 'online' && <p><strong>Meeting Link:</strong> {group.online_meeting_link || "Generating..."}</p>}
                <Link to={`/group/${group._id}`} className="card-link">View Details</Link>
              </div>
            )) : <p>You are not a member of any groups.</p>}
          </div>

          <h2>Groups You Created</h2>
          <div className="card-container">
            {createdGroups.length > 0 ? createdGroups.map(group => (
              <div className="card" key={group._id}>
                <h2>{group.subject}</h2>
                <p><strong>Meeting Time:</strong> {new Date(group.meeting_time).toLocaleString()}</p>
                {group.session_type === 'offline' && <p><strong>Location:</strong> {group.location}</p>}
                {group.session_type === 'online' && <p><strong>Meeting Link:</strong> {group.online_meeting_link || "Generating..."}</p>}
                <div style={{ display: 'flex', gap: '10px' }}>
                  <Link to={`/group/${group._id}`} className="card-link">View Details</Link>
                  <button
                    onClick={() => handleDelete(group._id)}
                    style={{ backgroundColor: 'red', color: '#fff', border: 'none', padding: '8px 12px', borderRadius: '4px', cursor: 'pointer' }}
                  >
                    Delete
                  </button>
                </div>
              </div>
            )) : <p>You haven't created any groups.</p>}
          </div>

          <h2>Other Groups</h2>
          <div className="card-container">
            {otherGroups.length > 0 ? otherGroups.map(group => (
              <div className="card" key={group._id}>
                <h2>{group.subject}</h2>
                <p><strong>Meeting Time:</strong> {new Date(group.meeting_time).toLocaleString()}</p>
                {group.session_type === 'offline' && <p><strong>Location:</strong> {group.location}</p>}
                {group.session_type === 'online' && <p><strong>Meeting Link:</strong> {group.online_meeting_link || "Generating..."}</p>}
                <Link to={`/group/${group._id}`} className="card-link">View Details</Link>
              </div>
            )) : <p>No other groups available.</p>}
          </div>

          <div style={{ marginTop: '20px' }}>
            <Link to="/create" className="card-link">Create a New Study Group</Link>
          </div>
        </>
      ) : (
        <>
          <h2>All Study Groups</h2>
          <div className="card-container">
            {otherGroups.length > 0 ? otherGroups.map(group => (
              <div className="card" key={group._id}>
                <h2>{group.subject}</h2>
                <p><strong>Meeting Time:</strong> {new Date(group.meeting_time).toLocaleString()}</p>
                {group.session_type === 'offline' && <p><strong>Location:</strong> {group.location}</p>}
                {group.session_type === 'online' && <p><strong>Meeting Link:</strong> {group.online_meeting_link || "Generating..."}</p>}
                <Link to={`/group/${group._id}`} className="card-link">View Details</Link>
              </div>
            )) : <p>No groups available.</p>}
          </div>
          <p>Please log in to join a study group.</p>
        </>
      )}
    </div>
  );
};

export default Dashboard;